import { t } from "i18next";

import { InfoPredictedPricePopover } from "#modules/quoteRequestLines/InfoPredictedPricePopover";
import { marginPercentOfCost } from "#shared/helpers/prices";
import { Stack } from "#shared/view/components/Stack";
import { Text } from "#shared/view/components/Text";
import { formatPrice } from "shared";

export const PriceDisplay = ({
  primaryCostLabel,
  primaryCost,
  secondaryCost,
  secondaryCostLabel,
  marginPrice,
  disclaimer = false,
  condensed = false,
}: {
  primaryCost: number;
  primaryCostLabel: string;
  secondaryCost?: number;
  secondaryCostLabel?: string;
  marginPrice?: number;
  disclaimer?: boolean;
  condensed?: boolean;
}) => {
  const marginPercentage = marginPercentOfCost(marginPrice, primaryCost);

  return (
    <Stack gap="0" align="flex-end">
      {!condensed && (
        <Text c="dimmed" ta="right">
          {disclaimer && <InfoPredictedPricePopover />}
          {primaryCostLabel}
        </Text>
      )}

      <Text fz="xl" c="violet" ta="right">
        {formatPrice(primaryCost)}
      </Text>

      {!condensed && secondaryCostLabel && (
        <Text size={"10px"} c="gray.4" ta="right">
          {secondaryCostLabel}: {formatPrice(secondaryCost)}
        </Text>
      )}

      {marginPrice && (
        <Text size={"11px"} c="gray.5" ta="right" py={2}>
          {`${t("settings.materials.volumetricPrice")} : ${formatPrice(
            marginPrice,
          )} (+${marginPercentage}%)`}
        </Text>
      )}
    </Stack>
  );
};
